import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HomePage } from "@/pages/HomePage";
import { ArticlePage } from "@/pages/ArticlePage";
import { CategoriesPage } from "@/pages/CategoriesPage";
import { AboutPage } from "@/pages/AboutPage";
import { useTheme } from "@/hooks/useTheme";

// Lazy-load heavy pages — keeps TipTap editor + admin out of the initial bundle
const LoginPage = lazy(() =>
  import("@/pages/LoginPage").then((m) => ({ default: m.LoginPage }))
);
const AdminLayout = lazy(() =>
  import("@/pages/AdminLayout").then((m) => ({ default: m.AdminLayout }))
);

function LazyFallback() {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="h-6 w-6 border-2 border-foreground/20 border-t-foreground rounded-full animate-spin" />
    </div>
  );
}

function App() {
  const { theme, toggleTheme } = useTheme();

  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <Header theme={theme} onToggleTheme={toggleTheme} />
        <div className="flex-1">
          <Suspense fallback={<LazyFallback />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/article/:slug" element={<ArticlePage />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/a-propos" element={<AboutPage />} />
              <Route path="/login" element={<LoginPage />} />
              {/* All admin routes are lazy-loaded together with auth check */}
              <Route path="/admin/*" element={<AdminLayout />} />
            </Routes>
          </Suspense>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
